
import { useState, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface MobileTripTypeSelectorProps {
  activeTab: string;
  onTabChange: (value: string) => void;
}

const MobileTripTypeSelector = ({ 
  activeTab, 
  onTabChange 
}: MobileTripTypeSelectorProps) => {
  const [selectedValue, setSelectedValue] = useState(activeTab);

  // Update the selector when activeTab changes (e.g., from parent component)
  useEffect(() => {
    setSelectedValue(activeTab);
  }, [activeTab]);

  const handleSelect = (value: string) => {
    setSelectedValue(value);
    onTabChange(value);
  };

  return (
    <div className="w-full font-newgrotesk">
      <Select value={selectedValue} onValueChange={handleSelect}>
        <SelectTrigger className="w-full bg-white border-gray-200 focus:ring-neon-green text-black font-newgrotesk">
          <SelectValue placeholder="Select trip type" className="text-black !text-black font-newgrotesk" />
        </SelectTrigger>
        <SelectContent className="bg-white font-newgrotesk">
          <SelectItem value="new" className="text-black font-newgrotesk">New</SelectItem>
          <SelectItem value="upcoming" className="text-black font-newgrotesk">Upcoming</SelectItem>
          <SelectItem value="completed" className="text-black font-newgrotesk">Completed</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default MobileTripTypeSelector;
